import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';

import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import DashboardFilter from '../components/dashboard-filter';
import ProfitChartBadgeComponent from '../components/dashboard/pofit-chart-badge';
import OperatorsChartBadgeComponent from '../components/dashboard/operators-chart-badge';
import DashboardCalendarComponent from '../components/dashboard/calendar';
import { PageModeCalendar, DateModeCalendar } from '../components/table-filter';
import LongBadgeComponent from '../components/dashboard/long-badge';
import LongBadgeClientComponent from '../components/dashboard/long-client-badge';
import InfoBadgeComponent from '../components/dashboard/info-badge';

class DashboardPage extends React.Component {
  localState = {
    loading: false,
    currentPageMode: PageModeCalendar.operators,
    currentDateMode: DateModeCalendar.days,
    data: [],
    expandedRows: []
  };
  store; // injected by Poa
  actions; // injected by Poa
  t; // injected by Poa


  constructor(props) {
    super(props);
    this.localState = observable(JSON.parse(
      (localStorage.getItem(`dashboardLocalState_${this.store.auth.currentHost}`))
    ) || this.localState);
  }

  onFilterChange = async (user) => {
    this.store.dashboard.filters.teamLead = user;
  };

  onPageModeChange = async event => {
    switch (event.target.value) {
      case PageModeCalendar.accounts: {
        this.localState.currentPageMode = PageModeCalendar.accounts;
        break;
      }
      case PageModeCalendar.operators: {
        this.localState.currentPageMode = PageModeCalendar.operators;
        break;
      }
      case PageModeCalendar.clients: {
        this.localState.currentPageMode = PageModeCalendar.clients;
        break;
      }
      default:
        console.error('Unknown page type', event.target.value);
        break;
    }
  };

  onDateModeChange = async event => {
    switch (event.target.value) {
      case DateModeCalendar.days: {
        this.localState.currentDateMode = DateModeCalendar.days;
        break;
      }
      case DateModeCalendar.monthes: {
        this.localState.currentDateMode = DateModeCalendar.monthes;
        break;
      }
      default:
        console.error('Unknown date type', event.target.value);
        break;
    }
  };

  onCreateDashboard = async () => {
    const { fetchNewDashboard } = this.actions.dashboardActions;
    this.localState.expandedRows = [];
    await fetchNewDashboard({
      calendarPageMode: this.localState.currentPageMode,
      calendarDateMode: this.localState.currentDateMode
    });

    localStorage.setItem(`dashboardLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  render() {
    const {
      data,
      profitData,
      dataPrevious,
      profitDataPrevious,
      dashboardUsers,
      dashboardClients,
      filters,
      dataLoading,
      profitLoading,
      calendarLoading,
      usersLoading,
      clientsLoading,
    } = this.store.dashboard;
    const { setDates } = this.actions.dashboardActions;

    return (
      <RouteLoading
        meta={this.store.dashboard.meta}
        render={() => {
          return (
            <>
              <Navbar />

              <div className='under-navbar-content'>
                <div className='container home'>
                  <div>
                    <DashboardFilter
                      getTableNode={() => this.node}
                      state={filters}
                      onDatesChange={setDates}
                      currentPageMode={this.localState.currentPageMode}
                      currentDateMode={this.localState.currentDateMode}
                      onPageModeCalendarChange={this.onPageModeChange}
                      onDateModeCalendarChange={this.onDateModeChange}
                      render={() =>
                        <div key={''} style={{ display: 'flex' }}>
                          <div style={{ verticalAlign: 'middle' }}>
                            <button
                              type='button'
                              onClick={this.onCreateDashboard}
                              className='dashboard_button'>
                              ОБНОВИТЬ
                            </button>
                          </div>
                        </div>
                      } />
                  </div>
                  <div className='cards-dashboard'>
                    <div className='cards-container'>
                      <div className='cards-row'>
                        <LongBadgeComponent
                          name='План'
                          dataCurrent={data.plan}
                          dataPrevious={dataPrevious.plan}
                          progressData={{
                            value: data.total > 0 ? Math.floor(data.total / data.plan * 100) : 100,
                            max: 100
                          }}
                          progressDataPrevious={{
                            value: dataPrevious.total > 0 ? Math.floor(dataPrevious.total / dataPrevious.plan * 100) : 100,
                            max: 100
                          }}
                          is_loading={dataLoading}
                        />
                        <LongBadgeComponent
                          name='Доход'
                          dataCurrent={data.total}
                          dataPrevious={dataPrevious.total}
                          is_loading={dataLoading}
                        />

                        {(this.store.auth.currentHost !== 'of' && <>
                          <LongBadgeComponent
                            name='Подарки'
                            dataCurrent={data.gifts}
                            dataPrevious={dataPrevious.gifts}
                            is_loading={dataLoading}
                          />
                          <LongBadgeComponent
                            name='Штрафы'
                            dataCurrent={data.penalty}
                            dataPrevious={dataPrevious.penalty}
                            is_loading={dataLoading}
                          />
                        </>)}
                      </div>

                      ({this.store.auth.accessLevel === 'agency' &&
                        <div className='cards-row'>
                          <InfoBadgeComponent
                            name='Кол-во новых сотрудников'
                            data={dashboardUsers || 0}
                            is_loading={usersLoading}
                          />
                          <LongBadgeClientComponent
                            name='К-во клиентов'
                            dashboardClients={dashboardClients}
                            is_loading={clientsLoading}
                          />
                          <InfoBadgeComponent
                            name='Количество платящих клиентов'
                            data={dashboardClients ? dashboardClients.current_count || 0 : 0}
                            is_loading={clientsLoading}
                          />
                        </div>})

                      <div className='cards-row'>
                        <ProfitChartBadgeComponent name='Динамика за период' profitData={profitData.data} is_loading={profitLoading} />
                        <OperatorsChartBadgeComponent name='По Операторам' data={profitData.operators} is_loading={profitLoading} />
                      </div>
                      <div className='cards-row'>
                        <ProfitChartBadgeComponent name='Динамика за прошлый период' profitData={profitDataPrevious.data} is_loading={profitLoading} />
                        <OperatorsChartBadgeComponent name='По Операторам' data={profitDataPrevious.operators} is_loading={profitLoading} />
                      </div>
                      <div className='cards-row dashboard-calendar-row'>
                        <DashboardCalendarComponent name="Календарь" localState={this.localState} is_loading={calendarLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      />
    );
  }
}

export default Component({ namespaces: ['dashboard'] })(DashboardPage);
